import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

const SearchComponent = ({ onSearchChange }) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleSearch = () => {
    setIsSearchVisible(!isSearchVisible);
    if (isSearchVisible) {
      setSearchQuery(""); // Clear search query when hiding the search bar
      onSearchChange(""); // Notify parent that search is cleared
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    onSearchChange(value); // Call the parent's onSearchChange prop
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // The search logic is handled in the parent component
  };

  return (
    <div
      className="search-container"
      style={{ display: "flex", alignItems: "center" }}>
      <FaSearch
        onClick={toggleSearch}
        style={{
          cursor: "pointer",
          fontSize: "1.3rem",
          color: "#687280",
          marginRight: "10px",
        }}
      />

      {isSearchVisible && (
        <form onSubmit={handleSearchSubmit} style={{ display: "flex" }}>
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search projects..."
            style={{
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginRight: "5px",
            }}
          />
          <button
            type="submit"
            style={{
              padding: "8px 12px",
              backgroundColor: "#006089",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}>
            Search
          </button>
        </form>
      )}
    </div>
  );
};

export default SearchComponent;
